import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { FormattedMessage } from "react-intl";

class SalesForceActionPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: true,
    };
  }

  open = () => this.setState({ show: true });
  close = () => {
    this.setState({ show: false });
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  };

  handleStartChat = () => {
    const detail = {
      userName: this.props.userName || "",
      userEmail: this.props.userEmail || "",
      propertyName: this.props.propertyName || "",
      chainName: this.props.chainName || "",
      chatHistory: this.props.chatHistory || "",
      userType: this.props.userType || "",
    };
    console.log("Dispatching handover_to_salesforce with detail:", detail);
    window.dispatchEvent(
      new CustomEvent("handover_to_salesforce", {
        bubbles: true,
        composed: true,
        detail,
      }),
    );
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  };

  handleCreateCase = () => {
    if (typeof this.props.onCreateCase === "function") {
      console.log("Creating case...");
      this.props.onCreateCase();
    }
    //this.close();
  };

  render() {
    const { show } = this.state;
    return (
      <Modal isOpen={show} toggle={this.close}>
        <ModalHeader toggle={this.close}>
          {this.props.title || (
            <FormattedMessage
              id="simpleaction.title"
              defaultMessage="Choose an Action"
            />
          )}
        </ModalHeader>
        <ModalBody style={{ textAlign: "center", padding: "2rem 1.5rem" }}>
          <FormattedMessage
            id="simpleaction.body"
            defaultMessage={
              "Please select one of the following options.{br}{b}Create a Case{/b} to submit a support request, or {b}Start a Chat{/b} to connect with an agent now."
            }
          >
            {(txt) => {
              // Replace {br} with <br /> and {b}...{/b} with <b>...</b>
              // This is a simple parser for this specific message
              const parts = [];
              let str = txt;
              while (str.length > 0) {
                const brIdx = str.indexOf("{br}");
                const bStart = str.indexOf("{b}");
                const bEnd = str.indexOf("{/b}");
                if (brIdx === 0) {
                  parts.push(<br key={parts.length} />);
                  str = str.slice(4);
                } else if (bStart === 0 && bEnd > 0) {
                  const boldText = str.slice(3, bEnd);
                  parts.push(<b key={parts.length}>{boldText}</b>);
                  str = str.slice(bEnd + 4);
                } else if (brIdx > -1 && (brIdx < bStart || bStart === -1)) {
                  parts.push(str.slice(0, brIdx));
                  str = str.slice(brIdx);
                } else if (bStart > -1 && (bStart < brIdx || brIdx === -1)) {
                  parts.push(str.slice(0, bStart));
                  str = str.slice(bStart);
                } else {
                  parts.push(str);
                  break;
                }
              }
              return parts;
            }}
          </FormattedMessage>
        </ModalBody>
        <ModalFooter style={{ justifyContent: "center" }}>
          <Button
            color="primary"
            onClick={this.handleStartChat}
            style={
              this.props.buttonColor
                ? {
                    backgroundColor: this.props.buttonColor,
                    borderColor: this.props.buttonColor,
                    color: "#fff",
                  }
                : undefined
            }
          >
            <FormattedMessage
              id="simpleaction.startchat"
              defaultMessage="Start a Chat"
            />
          </Button>
          <Button
            color="secondary"
            onClick={this.handleCreateCase}
            style={
              this.props.buttonColor
                ? {
                    backgroundColor: this.props.buttonColor,
                    borderColor: this.props.buttonColor,
                    color: "#fff",
                  }
                : undefined
            }
          >
            <FormattedMessage
              id="simpleaction.createcase"
              defaultMessage="Create a Case"
            />
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default SalesForceActionPopup;
